import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ExpeditionStatus } from 'src/app/models/enums';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { images } from '../../../../images';
import { StorageService, UtilsService } from 'src/app/services';
import {
  TRIP_FILTER_KEYS,
  hasAnyFilterKey,
  deserializeTripsFilters,
  parseTripsFiltersFromStorage,
  DEFAULT_TRIP_STATUS,
  ITripsFilters,
} from 'src/app/filters';

@Component({
    selector: 'app-trip-search-bar',
    templateUrl: './trip-search-bar.component.html',
    styleUrl: './trip-search-bar.component.scss',
    standalone: false
})
export class TripSearchBarComponent implements OnInit, OnDestroy {

  @Input() placeholder = '';
  @Input() searching = false;
  @Input() searchValue = '';
  @Output() filter = new EventEmitter();
  @Output() searchEventEmitter = new EventEmitter<string>();

  public filterOpened = false;
  public filtersApplied = 0;

  public images = images;

  private queryParamsSub?: Subscription;

  constructor(
    public literalService: LiteralService,
    public storageService: StorageService,
    public utilsService: UtilsService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.updateFilters();
    this.queryParamsSub = this.activatedRoute.queryParamMap.subscribe(() => this.updateFilters());
  }

  ngOnDestroy(): void {
    this.queryParamsSub?.unsubscribe();
  }

  search(event: any) {
    this.searchEventEmitter.emit(event);
  }

  async updateFilters() {
    const filters = await this.resolveCurrentFilters();
    if (!filters) {
      this.filtersApplied = 0;
      return;
    }
    const filtersForCount: any = { ...filters };
    // The availability filter is shown in the page title and has no control in the panel,
    // so counting it would give a badge the user cannot clear from there.
    delete filtersForCount.selectedAvailabilityId;
    const isDefaultStatus = filtersForCount.selectedStatus?.length === DEFAULT_TRIP_STATUS.length
      && DEFAULT_TRIP_STATUS.every((s: ExpeditionStatus) => filtersForCount.selectedStatus.includes(s));
    if (isDefaultStatus || !filtersForCount.selectedStatus?.length) {
      filtersForCount.selectedStatus = [];
    }
    this.filtersApplied = this.utilsService.getFiltersCount(filtersForCount);
  }

  private async resolveCurrentFilters(): Promise<ITripsFilters | null> {
    const params = this.activatedRoute.snapshot.queryParamMap;
    if (hasAnyFilterKey(params, TRIP_FILTER_KEYS)) {
      return deserializeTripsFilters(params);
    }
    return parseTripsFiltersFromStorage(await this.storageService.getTripsFilters());
  }

}
